import { AbstractBitBoardSet32 } from './AbstractBitBoardSet32';
import { BitBoardEntity } from '../../../utils/BitBoardEntity';

export class BitBoardBitSetForMinimum32 extends AbstractBitBoardSet32{
    allocateConcreteInternal( height:number, id:number ):void{
        let currentBucket:number = id >> 5;
        let idx:number = id & AbstractBitBoardSet32.REST_MASK;
        let currentIdx:number = 1 << (idx);
        if ( this.longTree[this.currentTreeLevel - height] == undefined ) {
            console.trace("kokos");
        }
        if( this.longTree[this.currentTreeLevel - height][currentBucket] == undefined ) {
            console.trace("kokos");
        }
        if( (~this.longTree[this.currentTreeLevel - height][currentBucket]) == 0 ){
            throw new Error("Trying to set value in full bucket.");
        }
        if( (this.longTree[this.currentTreeLevel - height][currentBucket] & currentIdx ) != 0 ){
            throw new Error("Trying to set the sema bit again.");
        }
        this.longTree[ this.currentTreeLevel - height ][ currentBucket ] |= currentIdx;
        let fullAtEnd:Boolean = ~(this.longTree[this.currentTreeLevel - height][ currentBucket]) == 0;
        if( fullAtEnd && height < this.currentTreeLevel ){
            this.allocateConcreteInternal( height + 1, currentBucket );
        }
    }
    
    public allocateIds( length:number ):Array<number>{
        let newIds:Array<number> = new Array();
        for( let i:number = 0; i < length; i++ ){
            newIds[ i ] = this.allocate(); 
        }
        return newIds;
    }
    
    traverseTree( height:number, toReturn:Array<number>, bucketIdx:number ):Boolean{
        let currentValue:number = this.longTree[height][bucketIdx];
        currentValue = BitBoardEntity.numberOfTrailingZeros( ~currentValue );
        if( height < this.currentTreeLevel ){
            let nextBucketIdx:number = ( bucketIdx << 5 ) + currentValue;
            toReturn[0] += currentValue << AbstractBitBoardSet32.powers[ this.currentTreeLevel - height ];
            let lowerLevelFull:Boolean = this.traverseTree(height + 1, toReturn, nextBucketIdx );
            if( lowerLevelFull ){
                this.longTree[ height ][ bucketIdx ] |= (1 << currentValue);
                return ~this.longTree[height][bucketIdx] == 0;
            }
            return false;
        }else{
            toReturn[0] += currentValue;
            if( (this.longTree[height][bucketIdx] & (1 << currentValue)) != 0 ){
                throw new Error("Trying to set bit that already set, bug in implementation. ");
            }
            this.longTree[height][bucketIdx] |= (1 << currentValue);
            let full:Boolean = ~this.longTree[height][bucketIdx] == 0;
            if( full ){
                this.initialIdx = bucketIdx + 1;
            }
            return full;
        }
    }
    
    public free( id:number ):void{
        if( id < 0 ){
            throw new Error("Id must be above 0, you try to free: " + id );
        }
        this.initialLoad = false;
        this.currentSize--;
        this.freeInternal( 0, id );
    }
    
    public freeInternal( height:number, id:number ):void{
        let currentBucket:number  = id >> 5;
        let idx:number = id & AbstractBitBoardSet32.REST_MASK;
        let currentIdx:number = 1 << (idx);
        let fullAtStart:Boolean = ~( this.longTree[this.currentTreeLevel - height][ currentBucket] ) == 0;
        
        if( (this.longTree[this.currentTreeLevel - height][currentBucket] & currentIdx ) == 0 ){
            throw new Error("Trying to free bit that is not set: " + id + ", on level: " + ( this.currentTreeLevel - height) + ", with maxTreeLEvel: " + this.currentTreeLevel);
        }
        this.longTree[ this.currentTreeLevel - height ][ currentBucket ] &= ~currentIdx;
        if( fullAtStart && height < this.currentTreeLevel ){
            this.freeInternal( height + 1, currentBucket );
        }
    }

    public allocate():number{
        if( this.currentSize == this.maxCapacity ){
            this.expand(this.longTree, false);
        }
        this.currentSize++;
        if( this.initialLoad ){
            let initialValue:number = this.longTree[ this.currentTreeLevel ][this.initialIdx];
            let currentValue:number = BitBoardEntity.numberOfTrailingZeros( ~initialValue );
            if( !( currentValue == 31 ) ){
                this.longTree[ this.currentTreeLevel ][ this.initialIdx ] |= 1 << currentValue ;
                return currentValue + ( this.initialIdx << 5);
            }
        }
        let newId:Array<number> = new Array();
        newId[0] = 0;
        this.traverseTree( 0, newId, 0);
        return newId[0];
    }
}